module.exports = __webpack_public_path__ + "static/media/logo.ffb197c6.png";